import React, { Component } from "react";
import CustomInput from "./CustomInput";

class GenericHeader extends Component {
  state = {};
  constructor() {
    super();
    this.changes = {};
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.jsonObj !== prevState.layout) {
      return { layout: nextProps.jsonObj }; // <- this is setState equivalent
    } else {
      return null;
    }
  }
  getInputNewData = (property, value) => {
    this.changes[property] = value;
    this.props.setHeaderInfo(this.changes);
  };
  renderInputs = () => {
    if (this.state.layout !== undefined) {
      const item = this.state.layout.map((item, key) => {
        if (this.state[item.item.intemName] !== item) {
          this.setState({ [item.item.intemName]: item });
        }
        return (
          <CustomInput
            key={key}
            item={item}
            size={item.size}
            handleNewData={this.getInputNewData}
            functions={this.props.functions}
            warehouseList={this.props.warehouseList}
          />
        );
      });
      return item;
    }
  };

  render() {
    const inputs = this.renderInputs();

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap"
        }}
      >
        {inputs}
      </div>
    );
  }
}

export default GenericHeader;
